import { FirestoreV8Compat } from '../Firebase';
import Photo, { PhotoConverter } from '../model/Photo';


export async function createPhoto(photo: Photo) {
  const convertedPhoto = PhotoConverter.toFirestore(photo);
  return FirestoreV8Compat.collection('gallery').add(convertedPhoto);
}

